import { cancelSubscriptionRenew, restoreSubscription, startWallet } from "@/api/subscriptions";
import { ConfirmCancelModal } from "@/components/customComponents/confirmCancelModal";
import { AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { usePreserveQueryParamsNavigate } from "@/hooks/usePreserveQueryParamsNavigate";
import { logEvent } from "@/lib/analytics";
import { cn } from "@/lib/utils";
import { EventName } from "@/types/analytics";
import { ELocalStorageKey } from "@/types/common";

import { AlertDialog } from "@radix-ui/react-alert-dialog";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

interface ActionBlockProps {
  variant: "active" | "available" | "history";
  subscriptionId: string;
  isDisabled: boolean;
}

const ActionBlock = ({ variant, subscriptionId, isDisabled }: ActionBlockProps) => {
  const navigate = usePreserveQueryParamsNavigate();
  const { t } = useTranslation("subscription");
  const cancelSubscription = useCallback(async () => {
    await cancelSubscriptionRenew(subscriptionId);
    navigate("/", {
      activeTab: "available",
    });
    toast.success(t("subscriptionCancelled"));
  }, [subscriptionId, navigate, t]);

  const buyAgain = useCallback(async () => {
    startWallet(subscriptionId, window.location.href);
  }, [subscriptionId]);

  const resumeSubscription = useCallback(async () => {
    try {

      await restoreSubscription(subscriptionId);
      logEvent({
        event: EventName.SubscriptionProductResume,
        user_id: localStorage.getItem(ELocalStorageKey.UserId) ?? "",
        product_id: subscriptionId,
      })
      navigate("/", {
        activeTab: "available",
      });
      toast.success(t("subscriptionResumed"))
    } catch (error) {
      const e = error as Error;
      toast.error(t("subscriptionResumeFailed"), {
        description: e?.message,
      })
    }
  }, [subscriptionId, navigate, t])


  if (variant === "active") {
    if (isDisabled) {
      return (
        <Button
          onClick={resumeSubscription}
          className={cn(
            "bg-system-bars-light rounded-lg p-2 text-primary-brand-light",
          )}
        >
          <span>{t("restoreSubscription")}</span>
        </Button>
      )
    }
    return (
      <AlertDialog>
        <AlertDialogTrigger
          disabled={isDisabled}
          className={cn(
            "bg-system-bars-light rounded-lg p-2 text-system-red-light",
            isDisabled && "text-system-gray-light cursor-not-allowed"
          )}
        >
          <span>{t("cancelSubscription")}</span>
        </AlertDialogTrigger>
        <ConfirmCancelModal
          title={t("subscriptionCancellation")}
          subtitle={t("areYouSureYouWantToCancel")}
          confirm={t("cancel")}
          cancel={t("keep")}
          confirmCallback={cancelSubscription}
        />
      </AlertDialog>
    );
  }

  if (variant === "history") {
    return (
      <button
        className={cn(
          "bg-system-bars-light rounded-lg p-2 text-primary-brand-light",
        )}
        onClick={buyAgain}
      >
        <span>{t("restoreSubscription")}</span>
      </button>
    );
  }
  return <></>;
};

export default ActionBlock;
